import React, { Component } from "react";

class PopUpBloqueadoConRazon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: undefined,
            maxLengthAllowed: 100
        };
    }

    SaveMotivo() {
        this.props.setMotivoBloqueo(this.props.usuario.Id, this.state.value != '' ? this.state.value : null)

        this.setState({ value: '' })

        $('#popUp-motivo-bloqueo').removeClass('open');
            
    }

    handleChange(event) {
        let supportsMaxLength = ('maxLength' in event.target);
        let value = event.target.value;

        if (!supportsMaxLength) {
            let maxValue = event.target.getAttribute("maxlength");

            if (value.length > maxValue) {
                value = value.substring(0, this.state.maxLengthAllowed);
            }
        }

        this.setState({ value: value });
    }

    render() {
        return (
            <div className="dropdown" id="popUp-motivo-bloqueo">
                <ul className="dropdown-menu">
                    <li>
                        <div className="row">
                            <div className="col-xs-12">
                                <p><b>El usuario fue bloqueado</b></p>
                                <p>Ingrese el motivo (opcional):</p>
                            </div>
                            <div className="col-xs-12 bottom-separator-xxs">
                                <textarea
                                    className="form-control"
                                    value={this.state.value}
                                    onChange={(event) => this.handleChange(event)}
                                    maxLength={this.state.maxLengthAllowed}
                                />
                            </div>
                            <div className="col-xs-12 text-right">
                                <button className="btn btn-secondary" type="button"
                                    onClick={() => this.SaveMotivo()} >Listo</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        )
    }
}

export default PopUpBloqueadoConRazon;